
import Vue from 'vue';
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import {
  factory,
  PositionsClient,
  PrintTemplatePostModel,
  ResultError,
  SysAdminTemplatesClient,
  EndorsementPrintTemplateModel,
TempFileModel,
SysAdminPrintBackgroundTemplatesClient,
PrintBackgroundOption,
EndorsementPrintTemplateType
} from "@/api-client";
import toasts from "@/components/Toasts";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import FileUploader from "@/components/FileUploader.vue";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import {Route} from "vue-router";
import {Prop} from "vue-property-decorator";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";
import ErrorsSummary from "@/components/ErrorsSummary.vue";

@Component({
  components: {
      SectionPageHeading,
      HeadingWave,
      AdministrationDetailviewLayout,
      FileUploader,
      HeadingGroup,
      LabelOptional,
      ButtonWithConfirm,
      ErrorsSummary
  }
})
export default class UpsertEndorsementPrintTemplate extends Vue {
  async beforeRouteEnter(to: Route, from: Route, next: Function) {
      try {

        const printBackgroundTemplateOtions = await new SysAdminPrintBackgroundTemplatesClient().options();
          to.meta!.props.printBackgroundTemplateOtions = printBackgroundTemplateOtions;
          const positionOptions = await new PositionsClient().positionOptions();

          if (to.params.type) {
              const existing = await new SysAdminTemplatesClient().getEndorsementPrintTemplate(to.params.type);

              to.meta!.props.preloadedModel = new EndorsementPrintTemplateModel({
                  id: existing.id,
                  printTemplateToUpdate: existing.printTemplateToUpdate
              } as EndorsementPrintTemplateModel);


                switch(existing.printTemplateToUpdate){
                    case EndorsementPrintTemplateType.ForForeignSeagoingShip:
                         to.meta!.props.preloadedprintBackgroundTemplateId = existing.forForeignSeagoingShipPrintBackgroundTemplateId;
                         break;
                    case EndorsementPrintTemplateType.ForForeignFastVessel:
                         to.meta!.props.preloadedprintBackgroundTemplateId = existing.forForeignFastVesselPrintBackgroundTemplateId;
                         break;
                    case EndorsementPrintTemplateType.ForSeagoingShipAndWithStcwRule:
                         to.meta!.props.preloadedprintBackgroundTemplateId = existing.forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId;
                         break;
                    case EndorsementPrintTemplateType.ForInlandVessel:
                         to.meta!.props.preloadedprintBackgroundTemplateId = existing.forInlandVesselPrintBackgroundTemplateId;
                         break;
                    case EndorsementPrintTemplateType.ForSeagoingShipAndWithoutStcwRule:
                         to.meta!.props.preloadedprintBackgroundTemplateId = existing.forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId;
                         break;
                    default:
                         null;
                }
          }
          next();
      } catch (e) {
          next(e);
      }
  }

  @Prop({required: false, default: () => factory.create(EndorsementPrintTemplateModel)})
  preloadedModel!: EndorsementPrintTemplateModel;

  @Prop({required: false, default: () => null})
  preloadedprintBackgroundTemplateId!: string;


  @Prop({required: false})
  printBackgroundTemplateOtions!: PrintBackgroundOption[];

  model = this.preloadedModel;
  validationError: ResultError = ResultError.createEmpty();

  printTemplate = factory.create(PrintTemplatePostModel);
  uploadedPrintTemplates: TempFileModel[] = []; // Separate variable for uploaded templates since file uploader expects an array as it's model.
  printBackgroundTemplateId?: string | null = this.preloadedprintBackgroundTemplateId

  async save() {
      this.validationError.clear();

      this.model.printTemplate = this.printTemplate;
      this.model.printTemplate.file = this.uploadedPrintTemplates[0];
      switch(this.model.printTemplateToUpdate){
        case EndorsementPrintTemplateType.ForForeignSeagoingShip:
            this.model.forForeignSeagoingShipPrintBackgroundTemplateId = this.printBackgroundTemplateId;
            break;
        case EndorsementPrintTemplateType.ForForeignFastVessel:
            this.model.forForeignFastVesselPrintBackgroundTemplateId = this.printBackgroundTemplateId;
            break;
        case EndorsementPrintTemplateType.ForSeagoingShipAndWithStcwRule:
            this.model.forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId = this.printBackgroundTemplateId;
            break;
        case EndorsementPrintTemplateType.ForInlandVessel:
            this.model.forInlandVesselPrintBackgroundTemplateId = this.printBackgroundTemplateId;
            break;
        case EndorsementPrintTemplateType.ForSeagoingShipAndWithoutStcwRule:
            this.model.forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId = this.printBackgroundTemplateId;
            break;
      }

      await new SysAdminTemplatesClient().updateEndorsementPrintTemplate(this.model)
        .then(
          () => {
            this.$router.push({name: 'endorsement-print-templates'});
            toasts.success(this.$ls.Administration_EndorsementPrintTemplates_Toast_EditSuccess);
          },
          (errorResponse: ResultError) => {
              this.validationError = errorResponse;
              toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
          });
  }
}
